import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=46d85b75&scoped=true"
import script from "./GeneralDetails.vue?vue&type=script&lang=js"
export * from "./GeneralDetails.vue?vue&type=script&lang=js"
import style0 from "./GeneralDetails.vue?vue&type=style&index=0&id=46d85b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d85b75",
  null
  
)

export default component.exports